import Routes from "./routes/routes";
import Header from "./components/header";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import "./assets/styles/main.scss";
import { SnackbarProvider } from 'notistack';
import { useRecoilValue } from "recoil";
import { showloader } from "./store/gloabalState";

import Loader from "../src/components/loader";

function App() {
  const loadershow = useRecoilValue(showloader);
  return (
    <SnackbarProvider>
      <div className="App">
        <Router>
          <Header />
          <Routes />
        </Router>
      </div>
      {
        loadershow &&
        <Loader />
      }
    </SnackbarProvider>
  );
}

export default App;
